import * as React from "react";

import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";
import { PageProps } from "src/pages/Router/routes";
import { useShutdownsApi } from "src/modules/shutdowns/api/shutdown.api";
import ShutdownForm from "src/modules/shutdowns/components/ShutdownForm";

/**
 * Shutdowns form
 *
 */
const CreateEditShutdownPage: React.ReactFCWithChildren<PageProps<unknown, {shutdownId?: string;}>> = props => {
  const shutdownId = props.match && props.match.params.shutdownId ? parseInt(props.match.params.shutdownId, 10) : null;
  const [ shutdownsResponse, getShutdown ] = useShutdownsApi("GET_SHUTDOWN");

  React.useEffect(() => {
    if (shutdownId) {
      getShutdown(shutdownId);
    }
  }, [ getShutdown, shutdownId ]);

  return (
    <Layout
      {...props}
      title="Shutdowns"
    >
      <MainContentWrapper fill>
        {(shutdownsResponse.data || !shutdownId) &&
          <ShutdownForm initialShutdown={shutdownsResponse.data || null} />}
      </MainContentWrapper>
    </Layout>
  );
};

export default CreateEditShutdownPage;
